"use strict"
exports.__esModule = true;
exports.CouchIconConfig = {
  name: 'CouchIcon',
  height: 512,
  width: 640,
  svgPath: 'M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z',
  yOffset: 0,
  xOffset: 0,
};
exports.CouchIcon = require('../createIcon').createIcon(exports.CouchIconConfig);
exports["default"] = exports.CouchIcon;